import React from "react";
import {
  View,
  Image,
  ImageBackground,
  Button,
  TouchableOpacity,
  StyleSheet,
  Platform,
  ScrollView,
  SafeAreaView,
} from "react-native";
import { Surface, ActivityIndicator } from "react-native-paper";
import { connect } from "react-redux";
import { getDiscalimer, clearDisclaimerData } from "./../../store/actions";
// import BackHandlerAndroid from './../AndroidBackHandler';
// import HTML from "react-native-render-html";
// import LinearGradientComponent from './../HeaderBackgroundComponent';
// import StylesColors from './../Colors';
// import OfflineHandler from './../OfflineHandler';
import { Styles, Text } from "./../../components/UI-Components";
import Header from "./../../components/Header";
import LoadingComponent from "./../../components/LoaderComponent";
import Container from '@material-ui/core/Container';


// import AdsScreen from './../Ads';
class DisclaimerScreen extends React.Component {
  state = {
    // any thing can write here
  };



  componentDidMount() {
    this.props.getDiscalimer();
  }

  isAd = () => {
    this.setState({
      isAdShow: true,
    });
  };

  render() {
    return (
      <>
       <Header
          title="Disclaimer"
          // headerRight
          // headerRightClick={() => alert()}
        />
        <div className={`${this.props.loading? "conditions" : 'full-height'} `}
        

          // style={{
          //   flex: 1,
          //   backgroundColor: Styles.white,
          //   height: "90vh",
          //   elevation: 4,
          //   paddingVertical: 30,
          // }}
        >
          <Container maxWidth='md'>
        
          {this.props.loading && (
          <View style={{ width: '100%', height: '90vh', justifyContent: 'center', alignItems: 'center' }}>
          {/* <ActivityIndicator /> */}
           <LoadingComponent styles={{width: 250, height: 250}}/>
          </View>
      
          )}
           <View style={styles.main}>
          {
            this.props._disclaimerData ?
                <ScrollView
                style={{
                  paddingHorizontal: 8,
                  textAlign: "justify",
                  paddingBottom: 50,
                  flex: 1,
                  marginBottom: 10,
                }}
              >
                {/* <View style={{marginTop:10,marginHorizontal:15, paddingBottom: this.state.isAdShow ? 60 : 0}}> */}
                {
                this.props._disclaimerData && Object.keys(this.props._disclaimerData).length > 0 && (
                  <div
                    style={{ flex: 1 }}
                    dangerouslySetInnerHTML={{
                      __html: this.props._disclaimerData?.description,
                    }}
                  ></div>
                )}
                {/* </View> */}
              </ScrollView>
             :
             <View style={{ width: '100%', height: '90vh', justifyContent: 'center', alignItems: 'center' }}>
             <Text style={{fontSize: 18, fontWeight: '700'}}>No Data</Text>
            </View>  
          }
          
          
          {/* </View> */}
          {/* {
                      !this.props.loading &&
                          <AdsScreen screenName={'DisclaimerScreen'} isAdCallBack={this.isAd}/>
                  } */}
          </View>
          </Container>        
        </div>
      </>  
    );
  }
}
const styles = StyleSheet.create({
  main: {
      flex: 1,
      backgroundColor: Styles.fiveMantraBgColor,
      marginTop: 20,
  }
})


const mapStateToProps = (state) => ({
  loading:
    state.disclaimer && state.disclaimer.loading && state.disclaimer.loading,
  error: state.disclaimer && state.disclaimer.error && state.disclaimer.error,
  errorInfo:
    state.disclaimer &&
    state.disclaimer.errorInfo &&
    state.disclaimer.errorInfo,
  _disclaimerData:
    state.disclaimer &&
    state.disclaimer.response &&
    state.disclaimer.response.disclaimer,
});

export default connect(mapStateToProps, { getDiscalimer, clearDisclaimerData })(
  DisclaimerScreen
);
